'use client';

import { c as _c } from "react/compiler-runtime";
import CookiePopup from '@components/cookie-popup/CookiePopup';
import Footer from '@components/footer/Footer';
import Header from '@components/header/Header';
import MenuMobile from '@components/menu-mobile/MenuMobile';
import ModalMenu from '@components/modal-menu/ModalMenu';
import { useGSAP } from '@gsap/react';
import { handleScrollY } from '@lib/store/slices/ComponentsSlice';
import { ScrollSmoother, ScrollTrigger } from '@lib/tools/gsap-init';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';
function BaseLayout(t0) {
  const $ = _c(24);
  const {
    isANewUser,
    menuMobile,
    children,
    commonModals,
    renderFooter,
    isMobile,
    deviceType
  } = t0;
  const root = useRef(null);
  const dispatch = useDispatch();
  let t1;
  if ($[0] !== dispatch) {
    t1 = () => {
      const smoother = ScrollSmoother.create({
        wrapper: "#smooth-wrapper",
        content: "#smooth-content",
        smooth: 1.2,
        effects: true,
        smoothTouch: 0.1
      });
      setTimeout(_temp, 500);
      smoother?.scrollTrigger?.scroller?.addEventListener("scroll", () => {
        dispatch(handleScrollY(smoother.scrollTrigger.scroll()));
      });
      return () => {
        if (smoother) {
          smoother.kill();
        }
      };
    };
    $[0] = dispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      scope: root
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useGSAP(t1, t2);
  let t3;
  if ($[3] !== deviceType || $[4] !== isMobile) {
    t3 = <Header isMobile={isMobile} deviceType={deviceType} />;
    $[3] = deviceType;
    $[4] = isMobile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="target" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isANewUser) {
    t5 = !isANewUser && <CookiePopup />;
    $[7] = isANewUser;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isMobile || $[10] !== renderFooter) {
    t6 = renderFooter && <Footer isMobile={isMobile} />;
    $[9] = isMobile;
    $[10] = renderFooter;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== children || $[13] !== t5 || $[14] !== t6) {
    t7 = <div id="smooth-wrapper" ref={root}><div id="smooth-content" className="App">{t4}{t5}{children}{t6}</div></div>;
    $[12] = children;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== menuMobile) {
    t8 = menuMobile && <MenuMobile />;
    $[16] = menuMobile;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ModalMenu />;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== commonModals || $[20] !== t3 || $[21] !== t7 || $[22] !== t8) {
    t10 = <>{t3}{t7}{t8}{commonModals}{t9}</>;
    $[19] = commonModals;
    $[20] = t3;
    $[21] = t7;
    $[22] = t8;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const content = t10;
  return content;
}
function _temp() {
  ScrollTrigger.refresh();
}
export default BaseLayout;